import { axiosTnaGet } from "../api/apiAxios"
import { segDneTokenUrl } from "../api/apiUrl"
import { getAuth } from "../api/apiUtil"
import { useAuth } from "./useAuth"

export const useTokenDne = () => {
    const { setAuth } = useAuth()

    const refresh = async () => {
        const url = segDneTokenUrl()
        const [dat_api, err_api] = await axiosTnaGet(url)
        const tokenDne = dat_api?.token
        if (!err_api)
            setAuth(prev => { return { ...prev, tokenDne } })
        else
            setAuth(getAuth(false))
        return tokenDne
    }

    return refresh
}